var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74734",
    "data-name": "Group 74734",
    transform: "translate(-9 -9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1656",
    "data-name": "Ellipse 1656",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(9 9)",
    fill: "#def5f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63260",
    "data-name": "Group 63260",
    transform: "translate(-98.14 -6.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222758",
    "data-name": "Path 222758",
    d: "M128.834,33.8l3.051-1.947h21.752l3.185,3.628V72.687H127.783l.441-21.341Z",
    fill: "#def5f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30595",
    "data-name": "Rectangle 30595",
    width: 28.363,
    height: 46.716,
    rx: 4,
    transform: "translate(128.179 32.125)",
    fill: "none",
    stroke: "#008372",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221783",
    "data-name": "Path 221783",
    d: "M135.107,136.491v2.59h-3.444v-2.59m21.395-1v3.59h-3.444v-2.59M129,110.361h27.239M131.59,96v7.18m0,10.77v7.18m-2.756,10.77h20.707m3.59,0h3.108",
    transform: "translate(0 -56.799)",
    fill: "none",
    stroke: "#008372",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_74727",
    "data-name": "Group 74727",
    transform: "translate(44.692 56.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222759",
    "data-name": "Path 222759",
    d: "M42.328,103.149H63.8l3.81,5.779v13.494h-29.6V108.929Z",
    transform: "translate(-37.668 -103.149)",
    fill: "#def5f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222750",
    "data-name": "Path 222750",
    d: "M664.922,795.213a2.4,2.4,0,0,0-.432-1.359l-3.095-4.429a1.893,1.893,0,0,0-1.548-.81l-10.137,0a.333.333,0,0,0-.186,0l-9.936,0a1.9,1.9,0,0,0-1.53.784l-3.7,5s0,.8,0,1.161c0,2-.063,9.564-.008,11.564a1.76,1.76,0,0,0,1.759,1.942l.485,0v.008h.187v.918a1.591,1.591,0,0,0,1.588,1.587h.954a1.594,1.594,0,0,0,1.589-1.6v-.907l18.1,0,.02,1.069a1.462,1.462,0,0,0,1.432,1.434l1.165,0a1.674,1.674,0,0,0,1.666-1.608c.015-.369.025-.587.025-.812a0,0,0,0,1,0,0h0a3.138,3.138,0,0,0,.733-.361,2.771,2.771,0,0,0,.933-2.357C664.978,804.846,664.936,797.579,664.922,795.213Zm-14.937-5.864,9.861,0a1.156,1.156,0,0,1,.945.5l3.118,4.462-13.926,0Zm-11.33.477a1.157,1.157,0,0,1,.934-.48l9.66,0v4.957l-13.832,0Zm1.487,20.163a.964.964,0,0,1-.964.962h-.815a.967.967,0,0,1-.963-.971v-.908h.13a0,0,0,0,1,0,0l.279,0h2.334Zm23.885-3.054c-.011.657-.174,1.11-.762,1.238l-.007,0a1.994,1.994,0,0,0-.709-1.364,1.383,1.383,0,0,0-1.8.476,1.263,1.263,0,0,0-.106,1.4,1.477,1.477,0,0,0,1.235.468,6.625,6.625,0,0,0,.714.05l.009.009v.163a1.342,1.342,0,0,1-1.389,1.524l-.577,0c-.792,0-.887-.624-.912-1.415l-.026-.676c-.013-.56-.719-.44-.787-.44-2.729-.018-9.176-.037-12.193-.055l-.613,0c-3.247-.021-6.989-.043-10.21-.065-.6,0-.847-.465-.865-1.128-.005-.174,0-.349,0-.523,0-1.058,0-7.67,0-8.728q0-1.213,0-2.427a.394.394,0,0,1,.4-.395l14.025,0a.358.358,0,0,0,.316,0l13.829,0a.394.394,0,0,1,.394.393c.007,2.82.013,8.018.02,9.489l.008,1.74c0,.09,0,.18,0,.269Zm-1.481,1.3a.006.006,0,0,1,0,0l0,0c-.671.075-1.059.2-1.279-.17-.161-.276.269-.836.524-.864.391-.042.638.321.713.724a2.478,2.478,0,0,1,.047.3Z",
    transform: "translate(-634.322 -788.6)",
    fill: "#028372",
    stroke: "#028372",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222751",
    "data-name": "Path 222751",
    d: "M742,1466.05h-3.148a.3.3,0,0,0-.3.3v.087a.3.3,0,0,0,.3.3H742a.3.3,0,0,0,.3-.3v-.086A.3.3,0,0,0,742,1466.05Z",
    transform: "translate(-735.964 -1449.18)",
    fill: "#028372",
    stroke: "#028372",
    strokeWidth: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.b737474bd7f51bddd5a15e309c9020bd.svg";
export { ForwardRef as ReactComponent };